import React, { useState, useEffect } from "react";
import { useGlobalLoader } from "contexts/GlobalLoaderContext";
import CreditPurchaseModal from "pages/Credits/CreditPurchaseModal";
import { CreditEntry, CreditEntryResponse } from "pages/Credits/types";
import {
  fetchUserCreditBalance,
  getUserCreditHistory,
} from "apis/creditService";

const CreditsButton: React.FC = () => {
  const { showLoader, hideLoader } = useGlobalLoader();
  const [creditBalance, setCreditBalance] = useState<string | null>("0");
  const [showCreditPurchaseModal, setShowCreditPurchaseModal] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);

  // Fetch credit balance on mount
  const fetchData = async () => {
    showLoader();
    setLoading(true);

    try {
      const balanceResponse = await fetchUserCreditBalance();
      setCreditBalance(String(balanceResponse.availableCredits));
    } catch (err) {
      console.error("Failed to fetch credit balance:", err);
    } finally {
      setLoading(false);
      hideLoader();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="ml-auto pb-4 md:mt-3">
      <div
        className="bg-[#30D28E26] border border-[#30D28E4D] rounded-[7px] flex flex-row items-center px-[12px] py-[3px] gap-[15px] box-border font-poppins max-w-full ml-auto"
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        <div className="flex flex-row justify-center items-center h-14 gap-[10px]">
          <div className="p-[5.5px] bg-[#30D28E]  rounded-full flex items-center justify-center">
            <span className="text-white font-semibold text-[14px] leading-[22px]">
              {loading ? "..." : (Number(creditBalance) < 10 ? "0" + creditBalance : creditBalance)}
            </span>
          </div>
          <span className="text-black font-normal text-[14px] leading-[28px] whitespace-nowrap">
            Tokens Balance
          </span>
        </div>

        <button
          onClick={() => setShowCreditPurchaseModal(true)}
          aria-label="Buy more credits"
          className="w-full bg-[#FFBC00] rounded-[5px] flex justify-center items-center px-[13px] py-[7px] gap-[10px]"
        >
          <span className="text-[#F5F9FE] font-semibold text-[14px] leading-[24px] whitespace-nowrap">
            Buy Tokens
          </span>
        </button>
      </div>

      <CreditPurchaseModal
        onPaymentComplete={fetchData}
        isOpen={showCreditPurchaseModal}
        onClose={() => setShowCreditPurchaseModal(false)}
      />
    </div>
  );
};

export default CreditsButton;
